import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRetrieveNamespacesQuery } from '../../../api/queries/retrieveNamespaces';

// use this local variable as a singleton for caching
let systemTranslation: any = null;

const useSystemTranslations = () => {
    const { i18n } = useTranslation();

    // get initial translations
    const [initialTranslations, setInitialTranslations] = useState<object | null>(systemTranslation);
    const loading = initialTranslations === null;
    const { data, loading: namespaceLoading } = useRetrieveNamespacesQuery({});
    const namespaces = useMemo(() => data?.namespaces || [], [data?.namespaces]);
    useEffect(() => {
        if (systemTranslation) {
            return;
        }

        // first clone it to protect the original translation instance
        const clonedI18n = i18n.cloneInstance();
        if (!namespaceLoading) {
            (async () => {
                // we retrieve all the namespaces from the system translation

                // then change language to one supported by the system
                await clonedI18n.changeLanguage('en');
                // then load namespaces we need to translations
                await clonedI18n.loadNamespaces(namespaces);

                // get resources & merge
                const translations = namespaces.reduce(
                    (acc, namespace) => ({ ...acc, [namespace]: clonedI18n.getResourceBundle('en', namespace) }),
                    {}
                );

                // update initial translations
                setInitialTranslations(translations);
                systemTranslation = translations;
            })();
        }
    }, [i18n, namespaceLoading, namespaces, setInitialTranslations]);

    return { initialTranslations, loading };
};

export default useSystemTranslations;
